import PropTypes from "prop-types"
import Head from "next/head"
import { getPath } from "helpers/getPath"
import {
  buildCollectionSchema,
  serializeJsonLd
} from "helpers/structuredData"

export default function Collection({ cars, locale, name, url }) {
  const cloudinaryBase = process.env.NEXT_PUBLIC_CLOUDINARY || ""
  const data = buildCollectionSchema(cars, {
    name,
    url,
    cloudinaryBase,
    getProductUrl: route =>
      `https://swipcar.com/${locale}${getPath(locale, route.page, route.params)}`
  })

  if (!data) return null

  return (
    <Head>
      {/* eslint-disable react/no-danger */}
      <script
        key={`renting-collection-${url}`}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }}
      />
      {/* eslint-enable react/no-danger */}
    </Head>
  )
}

Collection.propTypes = {
  cars: PropTypes.array.isRequired,
  locale: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}
